import axios from "axios";
import { useEffect, useState } from "react";

export interface WhatsNewFeedItem {
  description: string | undefined;
  link: string | undefined;
  date: string | undefined;
  tags: string[] | undefined;
}

export const RSS_FEED = "https://docs.codat.io/updates/rss.xml";

export const useParseWhatsNewFeed = () => {
  const [data, setData] = useState<WhatsNewFeedItem[]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchFeed = async () => {
      setLoading(true);
      await axios
        .get(RSS_FEED)
        .then((res) => {
          return new window.DOMParser().parseFromString(res.data, "text/xml");
        })
        .then((xml) => {
          const channel = xml.querySelectorAll("item");

          if (!channel.length) {
            throw new Error("Feed has no items");
          }

          const content = Array.from(channel).map((el) => {
            const tags = Array.from(el.getElementsByTagName("category")).map(
              (item) => item.textContent ?? ""
            );

            return {
              link:
                el.getElementsByTagName("link").item(0)?.textContent ??
                undefined,
              description:
                el.getElementsByTagName("title").item(0)?.textContent ??
                undefined,
              date:
                el.getElementsByTagName("pubDate").item(0)?.textContent ??
                undefined,
              tags: tags.every((item) => !item) ? undefined : tags,
            };
          });

          setData(content.slice(0, 3));
        })
        .catch(() => {
          setData([]);
          setError(true);
        });
      setLoading(false);
    };
    fetchFeed();
  }, []);

  return { data, loading, error };
};
